import React from 'react';
import { Form, Row, Col, Container } from 'react-bootstrap'
import { SectionSelectBox } from './SectionSelectBox';

export const LabeledSectionSelectBox = ({ sections, selectedSectionNumber, onSectionChanged }) => {
    if (!sections) {
        return null;
    }

    if (!sections.length) {
        return <p>No sections found for the manufacturer.</p>
    }

    return (
        <Container>
            <Form onSubmit={event => event.preventDefault()}>
                <Form.Group as={Row} controlId="sectionForm.SectionSelectBox">
                    <Form.Label column sm="2" md={50}>
                        Family:
                        </Form.Label>
                    <Col sm="10" md="100%">
                        <Form.Control
                            as={SectionSelectBox}
                            selectedSectionNumber={selectedSectionNumber}
                            sections={sections}
                            onSectionChanged={onSectionChanged}>
                        </Form.Control>
                    </Col>
                </Form.Group>
            </Form >
        </Container>
    )
}
